export const RECONNECT_BASE_MS = 1000
export const RECONNECT_MAX_BACKOFF_MS = 30_000
export const RECONNECT_MAX_ATTEMPTS = 6

// Zero pauses its run loop in the `error` state and only resumes on connect().
// Exponential backoff, capped, so a permanently broken environment can't hot-loop.
export function getReconnectDelay(attempt: number): number {
	const exp = RECONNECT_BASE_MS * 2 ** Math.max(0, attempt)
	return Math.min(RECONNECT_MAX_BACKOFF_MS, exp)
}
